import SvgIcon from '@material-ui/core/SvgIcon';

export default function Triad(props:any) {
  return (
    <SvgIcon viewBox='0 0 18 18' { ...props}>
     <path d="M9 0L12.4286 3.60721H9.85714V10.6864L15.4543 14.0772L16.7143 11.7505L18 16.6834L13.2857 18L14.5971 15.6463L9 12.2465L3.40286 15.6463L4.71429 18L0 16.6834L1.28571 11.7505L2.54571 14.0772L8.14286 10.6864V3.60721H5.57143L9 0Z" fill="currentColor"/>
    </SvgIcon>
  );
}